/* eslint-disable react/display-name */
import React, { useState } from 'react'
import { Transfer, Button } from 'antd'
import R from 'ramda'
import { sortStringArray } from 'core'
export default ({
  titles = ['Data Items', 'Selected'],
  rowKey = a => a.ident,
  render = a => a.display,
  isValidTransfer = () => true,
  isRightListSelectionStoreRequired = false,
  targetKeys,
  setTargetKeys,
  showSelectAll = false,
  sortAfter = false,
  dataSource = [],
  ...rest
}) => {
  // const [targetKeys, setTargetKeys] = useState(rest.targetKeys || [])
  const [rightTargetSelected, setRightTargetSelected] = useState([])

  const handleTransfer = (targetKeys, direction, moveKeys) => {
    if (isValidTransfer(targetKeys, direction, moveKeys))
      if (sortAfter) setTargetKeys(sortStringArray(targetKeys))
      else setTargetKeys(targetKeys)
  }
  const updownKeys = type => {
    let idx = targetKeys.indexOf(rightTargetSelected[0])
    if (type === 'UP') idx = idx - 1
    else idx = idx + 1
    if (idx < 0) idx = 0
    if (idx === targetKeys.length) idx = idx - 1
    const d = R.difference(targetKeys, rightTargetSelected)
    //  d.splice(idx, 0, rightTargetSelected)
    setTargetKeys(R.insertAll(idx, rightTargetSelected, d))

    // const d =
    // const r = R.difference(targetKeys, d)
    // if (type === 'UP') setTargetKeys([...r, ...d])
    // else setTargetKeys([...d, ...r])
  }

  const filterOption = (inputValue, option) => {
    let isFil = true
    if (!inputValue || inputValue.length <= 0) isFil = true
    else {
      isFil = option.displayName
        .toLocaleLowerCase()
        .includes(inputValue.toLocaleLowerCase())
    }
    return isFil
  }

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '10fr 1fr',
        gridColumnGap: '10px',
      }}
    >
      <Transfer
        style={{
          display: 'grid',
          gridTemplateColumns: '10fr 2fr 10fr',
          gridColumnGap: '10px',
        }}
        filterOption={filterOption}
        listStyle={{ height: '95%', width: 'inherit', margin: '5px' }}
        operationStyle={{ alignSelf: 'center', justifySelf: 'center' }}
        // dataSource={[{ ident: 'a', displayName: 'A' }, { ident: 'b', displayName: 'B' }]}
        dataSource={dataSource}
        rowKey={rowKey}
        render={render}
        titles={titles}
        showSearch
        showSelectAll={showSelectAll}
        targetKeys={targetKeys}
        // selectedKeys={selectedKeys}
        onChange={handleTransfer}
        // onSelectChange={this.handleSelectChange}
        // onScroll={this.handleScroll}
        // disabled={disabled}
        {...rest}
      >
        {({ direction, selectedKeys }) => {
          if (isRightListSelectionStoreRequired && direction === 'right') {
            if (rightTargetSelected.length !== selectedKeys.length)
              setRightTargetSelected(selectedKeys)
            else {
              if (rightTargetSelected.find(e => selectedKeys.indexOf(e) === -1))
                setRightTargetSelected(selectedKeys)
            }
          }
        }}
      </Transfer>
      {isRightListSelectionStoreRequired && (
        <div
          style={{
            alignSelf: 'center',
            justifySelf: 'center',
            display: 'grid',
            gridRowGap: '4px',
          }}
        >
          <Button
            icon="up"
            size="small"
            disabled={rest.disabled || rightTargetSelected.length === 0}
            onClick={() => updownKeys('UP')}
            type="primary"
          />
          <Button
            icon="down"
            size="small"
            disabled={rest.disabled || rightTargetSelected.length === 0}
            onClick={() => updownKeys('DOWN')}
            type="primary"
          />
        </div>
      )}
    </div>
  )
}
